import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

// Components.
import ModalContents from '../modal-contents';
import ModalOverlay from '../modal-overlay';

const Modal = ({
  children,
  dismiss,
}) => {
  // Define a function for dismissing the modal if the Escape key is pressed.
  const dismissOnEscape = (event) => {
    if ('Escape' === event.key) {
      dismiss();
    }
  };

  // Hook the Escape handler into the document on mount, and unhook on dismiss.
  useEffect(() => {
    document.addEventListener('keyup', dismissOnEscape);
    return () => document.removeEventListener('keyup', dismissOnEscape);
  });

  return (
    <div
      className="kauffman-modal"
      role="dialog"
    >
      <ModalOverlay dismiss={dismiss} />
      <ModalContents dismiss={dismiss}>
        {children}
      </ModalContents>
    </div>
  );
};

Modal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  dismiss: PropTypes.func.isRequired,
};

export default Modal;
